import { get } from 'vio-libs';
export function getAllMetrics() {
    return get('all-site-metrics');
}
export function getMetrics(locationSlug) {
    return get(`site-metrics?location=${locationSlug}`);
}
export function getRackMetrics(locationSlug, rackId) {
    return get(`site-metrics?location=${locationSlug}&device_location=r${rackId}`);
}
